import { render } from "./Confirmare.vue?vue&type=template&id=083fcde2&scoped=true"
import script from "./Confirmare.vue?vue&type=script&lang=js"
export * from "./Confirmare.vue?vue&type=script&lang=js"

import "./Confirmare.vue?vue&type=style&index=0&id=083fcde2&scoped=true&lang=css"

import exportComponent from "/home/ionut/PycharmProjects/frontend2/raportare/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-083fcde2"]])

export default __exports__